import { Filter } from "./filter.model";
import { FilterDef, FilterType } from "../../../../../../api/src/data-source/models/filter.model";

export function updateFilterInArray(filters: Filter[], id: string, newValue: Partial<Filter>) {
	return filters.map(f => {
		if (f.id === id) {
			return {
				...f,
				...newValue
			};
		}
		return f;
	});
}

export function getFilterTypeTitle(filterType: FilterType): string {
	switch (filterType) {
		case FilterType.Search:
			return $localize`:Filter Search Type Title@@filterSearchTypeTitle:Search`;
		case FilterType.Toggle:
			return $localize`:Filter Toggle Type Title@@filterToggleTypeTitle:Toggle`;
		case FilterType.SingleSelect:
			return $localize`:Filter Single Select Type Title@@filterSingleSelectTypeTitle:Single Select`;
		case FilterType.MultiSelect:
			return $localize`:Filter Multi Select Type Title@@filterMultiSelectTypeTitle:Multi Select`;
		case FilterType.Autocomplete:
			return $localize`:Filter Autocomplete Type Title@@filterAutocompleteTypeTitle:Autocomplete`;
		case FilterType.DateRange:
			return $localize`:Filter Date Range Type Title@@filterDate RangeTypeTitle:Date Range`;
		default:
			return;
	}
}

/**
 * Return a form builder object with controls for all fo the filters supplied.
 */
export function createFormGroup(filters: FilterDef[], controlOverrides: any = {}) {
	const filterFields = {};

	filters.forEach(f => {
		// Each filter type can have a different configuration for the form.
		// There is no default option because we want form types to be present all of the time.
		switch (f.type) {
			// String based inputs
			case FilterType.Search:
				filterFields[f.paramKey] = [f.value || ''];
				break;

			// Array based inputs
			case FilterType.MultiSelect:
			case FilterType.SingleSelect:
			case FilterType.Autocomplete:
				filterFields[f.paramKey] = [f.value || []];
				break;

			// Date based inputs
			case FilterType.DateRange:
				filterFields[`${f.extra?.prepend || ''}start${f.extra?.append || ''}`] = [];
				filterFields[`${f.extra?.prepend || ''}end${f.extra?.append || ''}`] = [];
				break;

			// Boolean based inputs
			case FilterType.Toggle:
				filterFields[f.paramKey] = f.value || false;
				break;

			case FilterType.Date:
				filterFields[f.paramKey] = [f.value || null];
				break;

			default:
				console.error('This filter is missing a supported type:', f);
				break;
		}
	});

	return {
		...filterFields,
		...controlOverrides
	};
}
